export default "__VITE_PUBLIC_ASSET__eabb9757__"